var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [{ name: "resize", rawName: "v-resize" }],
      staticClass: "vuestic-layout",
      class: _vm.classObject,
    },
    [
      _vm._t("default"),
      _c(
        "div",
        {
          staticClass: "content-wrap",
          staticStyle: { "padding-top": "20px" },
          attrs: { id: "content-wrap" },
        },
        [_vm._t("content")],
        2
      ),
      _c("div", { staticClass: "made-by-footer" }, [_vm._t("footer")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }